export default __webpack_public_path__ + "maps-examples-heatmap-example-1200-d7be4fd10bf82b2279c8625d36fcfbd4.webp";